import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import overview from "../../../../assets/images/overview-dark.png";
import * as React from 'react';
export default {
  PolypaneIntro,
  overview,
  React
};